const HIDDEN_ENVS = ["preprod", "production"];

export const IS_HIDDEN_ENV = HIDDEN_ENVS.includes(
  import.meta.env.VITE_APP_STAGE,
);
